module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABlSURBVCiRY2RgYGCYMHnmZwYGBh4G7OBLQW46L1aZCZNn/sehCaccEy4NhAALPtMLctMZidKISyGagV8KctN5WbApRAfIBsIMoY9TkeVJdipWjbicStBGXE7FJk52AmDEl9zwAQC+/DCxQ/6n9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/infomsgicon4.png
// module id = Iw2Q
// module chunks = 1